/* FAYARD CUSTOM. Popup newsletter : affichage (après le bandeau de cookies), inscription Klaviyo,
   étiquette de rappel. L'inscription passe par l'API publique Klaviyo (client/subscriptions),
   qui abonne le profil à la liste avec consentement et déclenche les flows liés à la liste. */
(function () {
  'use strict';

  var KEY = 'fy-nl-state';
  var TEXT = {
    fr: { invalid: 'Merci de saisir une adresse courriel valide.', failed: 'Une erreur est survenue. Merci de réessayer.' },
    en: { invalid: 'Please enter a valid email address.', failed: 'Something went wrong. Please try again.' }
  };

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
  }
  function write(state) {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }

  function consentOpen() {
    if (document.documentElement.classList.contains('fy-consent-open')) return true;
    var banner = document.getElementById('shopify-pc__banner');
    return !!(banner && banner.isConnected && getComputedStyle(banner).display !== 'none');
  }

  /* FAYARD CUSTOM : la popup ne doit jamais couper un achat ni un geste.
     - Jamais pour qui achète déjà : panier non vide ou ajout au panier pendant la visite.
     - Jamais pour qui est déjà connu : client connecté, déjà inscrit, ou arrivé depuis un courriel.
     - Jamais sur le panier, le compte ou la commande.
     - Jamais par-dessus autre chose : tiroir, menu, recherche, story, ou pendant la saisie.
     - Elle attend une pause : 3 s après la fermeture d'un tiroir, 1,2 s sans défilement ni toucher. */
  var NO_SHOW = 'fy-nl-no-show';
  var CALME_GESTE = 1200;
  var CALME_TIROIR = 3000;

  function noShowThisVisit() {
    try { return sessionStorage.getItem(NO_SHOW) === '1'; } catch (e) { return false; }
  }
  function skipThisVisit() {
    try { sessionStorage.setItem(NO_SHOW, '1'); } catch (e) {}
  }

  function isKnownVisitor() {
    if (window.__st && window.__st.cid) return true;
    try { if (localStorage.getItem('fy-email')) return true; } catch (e) {}
    var query = location.search || '';
    return /[?&]_kx=|utm_medium=(email|e-mail)|utm_source=klaviyo/i.test(query);
  }

  function isSensitivePage() {
    return /\/(cart|account|checkouts?|orders)(\/|$)/.test(location.pathname);
  }

  function hasCartItems() {
    return !!document.querySelector('.header__cart-link .header__cart-dot.is-visible');
  }

  function layerOpen() {
    if (document.documentElement.classList.contains('lock')) return true;
    if (document.querySelector('cart-drawer[open], header-sidebar[open], [aria-modal="true"][open], .drawer[open], .modal[open], .popover[open], .header-search[open]')) return true;
    var story = document.querySelector('.fy-stories__viewer');
    if (story) {
      var style = getComputedStyle(story);
      if (style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 && story.getBoundingClientRect().width > 0) return true;
    }
    return false;
  }

  function isTyping() {
    var el = document.activeElement;
    return !!(el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || el.isContentEditable));
  }

  class FayardNewsletterPopup extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.t = TEXT[this.dataset.locale === 'en' ? 'en' : 'fr'];
      this.form = this.querySelector('[data-nl-form]');
      this.email = this.querySelector('[data-nl-email]');
      this.submit = this.querySelector('[data-nl-submit]');
      this.error = this.querySelector('[data-nl-error]');
      this.teaser = this.querySelector('[data-nl-teaser]');
      this.state = read();

      this.querySelectorAll('[data-nl-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.close(true); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.classList.contains('is-open')) self.close(true);
      });
      if (this.teaser) {
        this.querySelector('[data-nl-open]').addEventListener('click', function () { self.open(); });
        this.querySelector('[data-nl-teaser-close]').addEventListener('click', function () {
          self.teaser.hidden = true;
          try { sessionStorage.setItem('fy-nl-teaser-hidden', '1'); } catch (e) {}
        });
      }
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.send(); });

      // Éditeur de thème : popup visible tout de suite pour pouvoir le régler
      if (this.hasAttribute('data-design-mode')) { this.hidden = false; this.open(); return; }

      if (this.state.subscribed) return; // déjà inscrit : ni popup ni étiquette

      var reshowMs = Number(this.dataset.reshowDays || 7) * 86400000;
      var dismissedRecently = this.state.dismissed && Date.now() - this.state.dismissed < reshowMs;
      this.hidden = false;

      if (dismissedRecently) { this.showTeaser(); return; }

      // On attend que le bandeau de cookies soit réglé, puis le délai choisi.
      // FAYARD CUSTOM : sur la toute première page vue, on laisse 20 s au visiteur pour découvrir le site ;
      // dès la 2e page de la visite, le délai réglé dans le thème s'applique.
      var views = 1;
      try {
        views = Number(sessionStorage.getItem('fy-nl-views') || 0) + 1;
        sessionStorage.setItem('fy-nl-views', String(views));
      } catch (e) {}
      var delay = views >= 2 ? Number(this.dataset.delay || 6) * 1000 : 20000;
      // Pages et visiteurs pour lesquels la popup n'a pas de sens : rien du tout, pas même le délai.
      if (isSensitivePage() || isKnownVisitor() || noShowThisVisit() || hasCartItems()) { skipThisVisit(); return; }

      // Un ajout au panier pendant l'attente annule la popup pour toute la visite.
      var cancelled = false;
      var cancel = function () { cancelled = true; skipThisVisit(); };
      document.documentElement.addEventListener('cart:change', cancel);
      document.addEventListener('submit', function (e) {
        if (e.target.matches && e.target.matches('form[action*="/cart/add"]')) cancel();
      }, true);

      var lastGesture = 0;
      ['scroll', 'wheel', 'touchstart', 'touchmove', 'pointerdown', 'keydown'].forEach(function (name) {
        window.addEventListener(name, function () { lastGesture = Date.now(); }, { passive: true, capture: true });
      });

      // FAYARD CUSTOM : jamais en même temps que le popup Espace frais (window.fyFraisBusy).
      var busy = function () { return consentOpen() || window.fyFraisBusy === true || layerOpen() || isTyping(); };
      var due = 0;
      var lastBusy = 0;
      var tick = function () {
        if (cancelled || hasCartItems()) { cancel(); return; }
        var now = Date.now();
        if (busy()) { lastBusy = now; setTimeout(tick, 400); return; }
        if (!due) due = now + delay; // le délai démarre une fois le bandeau de cookies réglé
        var calm = now >= due && now - lastBusy >= CALME_TIROIR && now - lastGesture >= CALME_GESTE;
        if (!calm) { setTimeout(tick, 400); return; }
        self.open();
      };
      setTimeout(tick, 800);
    }

    showTeaser() {
      var hidden = false;
      try { hidden = sessionStorage.getItem('fy-nl-teaser-hidden') === '1'; } catch (e) {}
      if (this.teaser && !hidden && !this.state.subscribed) this.teaser.hidden = false;
    }

    open() {
      this.hidden = false;
      if (this.teaser) this.teaser.hidden = true;
      var self = this;
      void this.offsetWidth;
      this.classList.add('is-open');
      this._lastFocus = document.activeElement;
      // Curseur dans le champ sur ordinateur seulement : sur mobile, le clavier cacherait la moitié de la popup.
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        setTimeout(function () { if (self.email && !self.state.subscribed) self.email.focus({ preventScroll: true }); }, 350);
      }
    }

    close(byUser) {
      this.classList.remove('is-open');
      if (byUser && !this.state.subscribed) {
        this.state.dismissed = Date.now();
        write(this.state);
        this.showTeaser();
      }
      if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus({ preventScroll: true });
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = !message;
      this.email.setAttribute('aria-invalid', message ? 'true' : 'false');
    }

    send() {
      var self = this;
      var email = (this.email.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { this.showError(this.t.invalid); return; }
      this.showError('');
      this.submit.disabled = true;

      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: this.dataset.source || 'Popup site Maison Fayard',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { 'Offre bienvenue': '10 $ offerts dès 100 $', 'Langue du site': this.dataset.locale }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: this.dataset.list } } }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.dataset.company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (!res.ok && res.status !== 202) throw new Error('HTTP ' + res.status);
        self.state.subscribed = Date.now();
        write(self.state);
        try { localStorage.setItem('fy-email', email); } catch (e) {}
        // Relie la session au profil (paniers abandonnés, navigation)
        try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (e) {}
        self.querySelector('[data-nl-step="form"]').hidden = true;
        self.querySelector('[data-nl-step="success"]').hidden = false;
        if (self.teaser) self.teaser.hidden = true;
      }).catch(function () {
        self.showError(self.t.failed);
      }).finally(function () {
        self.submit.disabled = false;
      });
    }
  }

  if (!customElements.get('fayard-newsletter-popup')) customElements.define('fayard-newsletter-popup', FayardNewsletterPopup);
})();
